import React from "react";

import { SearchOff } from "@mui/icons-material";

const EmptyState = ({
  title = "No models found",
  subtitle = "Try changing the filters or search term",
}: {
  title?: string;
  subtitle?: string;
}) => {
  return (
    <div className="w-full h-full flex items-center justify-center pb-12">
      <div className="flex flex-col gap-6 items-center">
        <SearchOff className="!w-28 !h-28 text-20" />
        <span className="text-24 font-bold">{title}</span>
        <span className="text-16">{subtitle}</span>
      </div>
    </div>
  );
};

export default EmptyState;
